import { defaultFont, primaryColor } from "../../../assets/jss/material-dashboard-pro-react.jsx";

const NotFoundStyle = {
    notFoundContianer: {
        ...defaultFont,
        height: "100%",
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },
    notFoundContent: {
        border: "1px solid",
        borderColor: primaryColor,
        padding: "10px",
        borderRadius: "5px",
        position: "absolute",
        top: "50%",
        transform: "translateY(-50%)",
    }
  };

  export default NotFoundStyle;